export default class LivingImage {
  constructor(id, title, /* markerImageURL, */ markerPatternURL, videoURL, patternRatio = 0.9) {
    this.id = id
    this.title = title
/*     this.image = markerImageURL */
    this.pattern = markerPatternURL
    this.video = videoURL
    this.patternRatio = patternRatio
    this.data = {}
    this.element = null
    this.videoElement = null
    this.markerElement = null
    this.loadingElement = null
  }
}
